/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import ResponsiveTable from "../../components/ResponsiveTable";
import moment from "moment";
import { Bar } from "ant-design-pro/lib/Charts";
import { Button, Checkbox, message } from "antd";
import { Job, OutputType, ProcessType, User } from "../../JmReact";


class VirtualShopDeclarationBranches extends Component {

    constructor(props: Props) {
        super(props);

        this.state = {

        }

        this.id = "VIRTUAL_SHOP_DECLARATION_BRANCHES";

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

        this.api = {
            get: "get_virtual_shop_declaration_branches",
            set: "set_virtual_shop_declaration_branches",
            delete: "delete_virtual_shop_declaration_branches",
        }
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate(p) {
        if (!p.visible && this.props.visible) {
            this.props.dataActions.genericDataSetFilter(
                this.id, this.props.user.companyCode, this.props.user.token, { _field: this.props.visible?._field }, this.api.get)
        }
    }

    refreshData = () => {
        this.props.dataActions.genericDataGetRequested(
            this.id, this.props.user.companyCode, this.props.user.token, this.api.get)
    }

    renderValue = (text, record) => {
        switch (this.props.visible?._type) {
            case "checkbox":
                return (<Checkbox checked={text == '1'} onChange={e => {
                    const { data } = this.props.data[this.id]
                    let newData = data.map((x, i) => {
                        if (i == record.index) {
                            let y = x.split("\f")
                            return `${y[0]}\f${y[1]}\f${e.target.checked ? '1' : '0'}\f${y[3]}`
                        } else {
                            return x
                        }
                    })
                    this.props.dataActions.setJson(this.id, { data: newData })
                }} />)

            default:
                return text
        }
    }

    handleOk = () => {
        const { data, headers } = this.props.data[this.id]
        this.sendAPI(this.api.delete, headers.join("\f") + "\r" + data[0], () => {
            this.sendAPI(this.api.set, headers.join("\f") + "\r" + data.join("\r"), () => {
                message.success(this.getText(21044))
                this.props.onCancel()
            })
        })
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        return (<GenericModal {...this.props}
            title={this.props.visible?._title}
            width={600}
            actionButtons={[{ buttonType: 'refresh', buttonFunction: this.refreshData }]}
            footer={[
                <Button key="back" onClick={this.props.onCancel}>{this.getText(21042)}</Button>,
                <Button key="create" type="primary" onClick={this.handleOk}>{this.getText(21043)}</Button>,
            ]}>
            <ResponsiveTable
                tableOnly
                idTable={this.props.data[this.id]}
                pagination={{ pageSize: 10 }}
                columns={[
                    { title: this.getText(21039), key: "bID", dataIndex: "bID", width: "20%", render: t => t },
                    { title: this.getText(21040), key: "bName", dataIndex: "bName", width: "50%", render: t => t },
                    { title: this.getText(21041), key: "bValue", dataIndex: "bValue", width: "30%", render: this.renderValue },
                ]}
            />
        </GenericModal>)
    }
}

export default VirtualShopDeclarationBranches;